import * as React from 'react'

import { SubMenuTabs } from '../../../components/SubMenu/SubMenuTabs'
import { INSIDER_VIEW_LABELS, InsiderView } from '../constants'
import { useInsiderTradingRouter } from '../hooks/useInsiderTradingRouter'

const MENU_TABS: Array<keyof typeof INSIDER_VIEW_LABELS> = [InsiderView.Index, InsiderView.Managers, InsiderView.Funds]
const MENU_TABS_MAP = {
  [InsiderView.Managers]: InsiderView.Managers,
  [InsiderView.ManagerDetails]: InsiderView.Managers,
  [InsiderView.ManagerHoldings]: InsiderView.Managers,
  [InsiderView.Funds]: InsiderView.Funds,
  [InsiderView.FundDetails]: InsiderView.Funds,
  [InsiderView.FundHoldings]: InsiderView.Funds,
}

export function Navigation() {
  const insiderTradingRouter = useInsiderTradingRouter()
  const menuItems = React.useMemo(() => {
    const activeView =
      (insiderTradingRouter.viewParams.view as keyof typeof MENU_TABS_MAP | undefined) || InsiderView.Index

    return MENU_TABS.map((view) => ({
      label: INSIDER_VIEW_LABELS[view],
      href: insiderTradingRouter.getInsiderTradingLink({ view }),
      isActive: activeView === InsiderView.Index ? view === InsiderView.Index : MENU_TABS_MAP[activeView] === view,
      reloadDocument: true,
    }))
  }, [insiderTradingRouter])
  return <SubMenuTabs size="xlarge" items={menuItems} />
}
